
import {Modal, Button, message} from 'antd';
import React from 'react';
import TableDOM from '../../../components/Table';
import { fetchHsbPayClrgRulePayorderInfo } from '../../../services/ZJBSyncDataRecord'
import {findDict, formatTime, isPlatform, moneyAddComma} from '../../../utils';
import moment from "moment";
import {dicPayChannel, dicPayType, liuShuiMeiJu} from "../../../axios/dictionaries";
import axios from "axios";
import {config, postFrom} from "../../../axios";
/**
 * @Author: zhao - 🍉
 * @Date: 2021-12-21 14:36:54
 * @LastEditTime: 2021-12-22 11:53:26
 * @LastEditors: zhao - 🍉
 * @Description: 惠市宝分账规则账单详情
 *
 */
class PayorderDetailListModal extends React.Component {
    constructor() {
        super();
        this.state = {
            visible: false,
            params: { //搜索参数
                keyword: '',          //关键字
                pageSize: 10,
                payType:'',
                mustPayDate:'',
                hsbPayChannelConfigId:0,
            },
            current: 1, //当前页
            hsbPayChannelConfigId: 0,
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
        };
    }

    open = (id) => {
        console.log("id=>"+id)
        this.setState({ visible: true,params:{hsbPayChannelConfigId:id},hsbPayChannelConfigId:id },function(){
            this.handleSearch();
        });
        console.log(this.state.hsbPayChannelConfigId)

    };

    close = () => {
        this.setState({ visible: false, tableData: [],hsbPayChannelConfigId:0,tableTotal:0,current:1 });
    };





    renderFooter = () => {
        return <Button onClick={() => this.close()}>关闭</Button>
    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        console.log(this.state.hsbPayChannelConfigId)
        let data = {};
        params.hsbPayChannelConfigId=this.state.hsbPayChannelConfigId;
        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        axios.all([
            postFrom({ url: config.API_traderecord_findPage, data }),
        ]).then(axios.spread((listRes, CountRes,CountDiscountRes) => {
            if(!isPlatform()){
                CountDiscountRes=0;
            }
            this.setState({ current: listRes.current, tableTotal: listRes.total, tableTotalMny: CountRes,tableDiscountTotalMny:CountDiscountRes, tableData: listRes.records, tableLoading: false })
        })).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        })
    }

    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
        } = this.state;
        const columns = [
            {
                title: '交易时间',
                dataIndex: 'tradeTime',

                render(text, record, index) {
                    return <span>
                <div>{record.tradeTime ? moment(record.tradeTime).format('YYYY-MM-DD HH:mm') : ""}</div>
            </span>
                }
            },
            {
                title: '我方流水 | 他方流水',
                dataIndex: 'orderNo',

                render(text, record, index) {
                    return <span>
                <div>{record.orderNo ? record.orderNo : null}</div>
                        {
                            record.orderNoThird
                                ? <React.Fragment>
                                    <div>{record.orderNoThird ? record.orderNoThird : null}</div>
                                </React.Fragment>
                                : null
                        }
            </span>
                }
            },
            {
                title: '交易金额 | 名称',
                dataIndex: 'amount',
                // align: 'right',
                render(text, record, index) {
                    return <span>
                <div>{record.amount ? moneyAddComma(record.amount) : null}</div>
                <div>{record.feeName}</div>
            </span>
                }
            },
            {
                title: '优惠金额',
                dataIndex: 'discountAmount',
                // align: 'right',
                render(text, record, index) {
                    return <span>
                <div>{moneyAddComma(record.discountAmount)}</div>
            </span>
                }
            },
            {
                title: '交易渠道 | 方式',
                dataIndex: 'payChannels',
                render(text, record, index) {
                    let now = dicPayChannel.find(item => item.value === record.payChannel);
                    let nows = dicPayType.find(item => item.value === record.payType);
                    if (now) {
                        return <span>
                    <div>{now ? now.title : null}</div>
                    <div>{nows ? nows.title : null}</div>
                </span>
                    }
                    return null
                }
            },
            {
                title: '房号',
                dataIndex: 'roomNos'
            },
            {
                title: '租客',
                dataIndex: 'customerName',

                render(text, record, index) {
                    return <span>
                <div>{record.customerName}</div>
                <div>{record.customerPhone}</div>
            </span>
                }
            },
            {
                title: '交易状态',
                dataIndex: 'status',

                render(text, record, index) {
                    let now = liuShuiMeiJu.find(item => item.value === text);
                    if (now)
                        return <span style={{color:now.color}}>
                    <div >{now.title}</div>
                </span>
                    return null
                }
            },
            {
                title: '商户 | 项目',
                dataIndex: 'mustPadyDate',

                render(text, record, index) {
                    return <span>
                <div>{record.merchantName}</div>
                <div>{record.projectName}</div>
            </span>
                }
            },
        ]
        return (
            <Modal title="汇集详情" width={1250} visible={this.state.visible} onCancel={this.close}  footer={<Button onClick={this.close}>关闭</Button>}>
                <TableDOM
                    columns={columns}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch}
                />
            </Modal>
        );
    }
}

export default PayorderDetailListModal;




// WEBPACK FOOTER //
// ./src/page/WftPayClrgRule/components/PayorderDetailListModal.jsx